import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataLogicService } from 'app/infrastructure/services/dataLogic.service';
import { Translator } from 'angular-translator';
import { LoaderService } from 'app/infrastructure/services/loader.service';
import {
  AlertService,
  GrowlType,
} from 'app/infrastructure/services/alert.service';
import {
  OrganizationCategory,
  DataLogic,
} from 'app/infrastructure/model/interfaces/dataLogic.interface';
import { ConfigurationType } from 'app/infrastructure/model/interfaces/configurationType.interface';
import { ConfigurationTypeService } from 'app/infrastructure/services/configurationType.service';
import { AutoCompleteService } from 'ng4-auto-complete';

@Component({
  selector: 'sx-detail-data-logic',
  templateUrl: './detail-data-logic.component.html',
  styleUrls: ['./detail-data-logic.component.css']
})
export class DetailDataLogicComponent implements OnInit {
  regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
  isNew = false;
  isLoading = false;
  checkeandCodigo = false;
  errors: any = [];
  editable = false;
  checked = false;
  dataLogicCode: string;
  typeOptions: ConfigurationType[];
  filteredTypeOptions: ConfigurationType[];
  showFilterTypeOptions: boolean = false;
  showAddTypeButton: boolean = false;
  SelectedOrganization: OrganizationCategory = {
    organizationCode: null,
    idCategory: null,
  };
  dataLogic: DataLogic = {
    dataLogicId: null,
    name: null,
    integrations: null,
    configurationType: null,
    integrationSelected: null,
    json: null,
    organizationCategorySelected: {
      organizationCode: null,
      idCategory: null,
    },
    categories: null,
  };
  options: any = { maxLines: 1000, printMargin: true };

  constructor(
    private dataLogicService: DataLogicService,
    public loader: LoaderService,
    private alertService: AlertService,
    private router: Router,
    private translator: Translator,
    private aRoute: ActivatedRoute,
    private configurationTypeSrv: ConfigurationTypeService,
    private autocompleteSrv: AutoCompleteService
  ) {}

  ngOnInit() {
    this.getCategoryTypes();
    this.aRoute.params.subscribe((params) => {
      this.dataLogicCode = params['coddatalogic'];
      if (this.dataLogicCode === undefined) {
        this.isNew = true;
        this.getList();
        return;
      }
      this.dataLogicService.getById(this.dataLogicCode).subscribe((data) => {
        if (!data) return this.router.navigateByUrl('/soc/404');

        this.dataLogic = data;
        this.dataLogic.json = JSON.stringify(
          JSON.parse(this.dataLogic.json),
          null,
          2
        );
      });
    });
  }

  back() {
    this.router.navigate(['../'], { relativeTo: this.aRoute });
  }

  getList() {
    this.dataLogicService.getList().subscribe((res) => {
      this.dataLogic.categories = res.categories;
      this.dataLogic.integrations = res.integrations;
    });
  }

  save() {
    if (this.validar()) {
      this.checkeandCodigo = true;
      this.dataLogicService.create(this.dataLogic).then((res) => {
        if (res) {
          this.alertService.showGrowl({
            type: GrowlType.SUCCESS,
            body: 'SISTEMA_CREADO_CORRECTAMENTE',
          });

          this.router.navigate(['../'], { relativeTo: this.aRoute });
        } else {
          this.alertService.showGrowl({
            type: GrowlType.DANGER,
            body: 'ERROR',
          });
        }
      });
    }
  }

  update(){
    if (this.validar()) {
      this.checkeandCodigo = true;
      this.dataLogicService.update(this.dataLogic).then((res) => {
        if (res) {
          this.alertService.showGrowl({
            type: GrowlType.SUCCESS,
            body: 'SISTEMA_CREADO_CORRECTAMENTE',
          });

          this.router.navigate(['../'], { relativeTo: this.aRoute });
        } else {
          this.alertService.showGrowl({
            type: GrowlType.DANGER,
            body: 'ERROR',
          });
        }
      });
    }
  }

  validar() {
    this.errors = [];

    if(this.dataLogic.dataLogicId){
      const validGuid = this.regexGuid.test(this.dataLogic.dataLogicId.toString());
      if(validGuid === false){
        this.errors['guid'] = <string>(
          this.translator.instant('GUID_INVALID')
        );
        return false;
      } else {
        return true;
      }
    } 
    
    if (!this.dataLogic.organizationCategorySelected) {
      this.errors['integration'] = <string>(
        this.translator.instant('INTEGRATION_SELECT')
      );
      return false;
    } else if (!this.dataLogic.configurationType) {
      this.errors['type'] = <string>this.translator.instant('TYPE_SELECT');
      return false;
    }
    if (this.dataLogic.configurationType.length <= 0) {
      this.errors['type'] = <string>(
        this.translator.instant('AL_MENOS_1_CARACTER')
      );
      return false;
    } else if (!this.dataLogic.organizationCategorySelected) {
      this.errors['organization'] = <string>(
        this.translator.instant('ORGANIZATION_SELECT')
      );
      return false;
    } else if (!this.dataLogic.name || this.dataLogic.name.length <= 0) {
      this.errors['name'] = <string>(
        this.translator.instant('AL_MENOS_1_CARACTER')
      );
      return false;
    } else if (this.dataLogic.name.length > 10) {
      this.errors['name'] = <string>(
        this.translator.instant('MAX_LONGITUD', { max: 10 })
      );
      return false;
    } else if (this.dataLogic.name === 'NEW') {
      this.errors['name'] = <string>this.translator.instant('INVALID_NAME');
      return false;
    } else if (!this.dataLogic.json || this.dataLogic.json.length <= 0) {
      this.errors['json'] = <string>(
        this.translator.instant('AL_MENOS_1_CARACTER')
      );
      return false;
    } else {
      return true;
    }
  }

  getCategoryTypes() {
    this.configurationTypeSrv.getAll().subscribe((res) => {
      this.typeOptions = res;
      this.filteredTypeOptions = res;
    });
  }

  updateList(value: string) {
    if (value != '' && value != null) {
      const newType = { id: null, type: value };
      this.configurationTypeSrv.create(newType).then((res) => {
        this.typeOptions.push(res);
        this.dataLogic.configurationType = value;
        this.findInTypeOptions(this.dataLogic.configurationType);
      });
    } else {
      this.errors['type'] = <string>this.translator.instant('TYPE_SELECT');
      return false;
    }
  }

  findInTypeOptions(value: string): void {
    if (value == '') this.showFilterTypeOptions = false;
    else {
      const finded = this.typeOptions.filter((x) =>
        x.type.toLowerCase().includes(value.toLowerCase())
      );
      if (finded.length > 0) {
        this.filteredTypeOptions = finded;
        this.showFilterTypeOptions = true;
        this.showAddTypeButton = false;
      } else {
        this.filteredTypeOptions = this.typeOptions;
        this.showFilterTypeOptions = false;
        this.showAddTypeButton = true;
      }
    }
  }

  selectDataLogicType(type: string) {
    this.dataLogic.configurationType = type;
    this.showFilterTypeOptions = false;
    this.showAddTypeButton = false;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/datalogic/detail/detail-data-logic.component.ts